import { render } from "./MerchantHeader.vue?vue&type=template&id=2ca831ff"
import script from "./MerchantHeader.vue?vue&type=script&lang=js"
export * from "./MerchantHeader.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__